import { jsx as _jsx } from "react/jsx-runtime";
import ContentLoader from 'react-content-loader';
export const SkeletonRoundSmall = () => (_jsx(ContentLoader, { speed: 2, width: 40, height: 40, viewBox: "0 0 40 40", backgroundColor: 'rgb(var(--background-secondary))', foregroundColor: 'rgb(var(--background-tertiary))', children: _jsx("circle", { cx: "20", cy: "20", r: "20" }) }));
